<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="tabChange">
      <el-tab-pane label="门店配置" name="storeConfigure">
        <store-configure></store-configure>
      </el-tab-pane>
      <el-tab-pane label="意向学员配置" name="student">
        <student-configure></student-configure>
      </el-tab-pane>
      <el-tab-pane label="假期设置" name="vacation">
        <vacation></vacation>
      </el-tab-pane>
      <el-tab-pane label="审批规则" name="rule">
        <tab-rule></tab-rule>
      </el-tab-pane>
      <el-tab-pane label="消息推送" name="push">
        <tab-push></tab-push>
      </el-tab-pane>
      <el-tab-pane label="提现配置" name="pay" v-if="showAutoWithdrawal">
        <pay-setting></pay-setting>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import tabRule from "./tabRule/index.vue";
import tabPush from "./tabPushTask.vue";
import storeConfigure from "./storeConfigure/index.vue";
import studentConfigure from "./studentConfigure/index.vue";
import vacation from "./vacation/index.vue";
import paySetting from "./paySetting/index.vue";
import { PageModule } from "@/store/module/page";
import { switchDetailApi } from "@/api/storeManagement";
import { withdrawalInfoApi } from "@/api/storeWallet";
import { staffCheckApi } from "@/api/makeUpLessons";

export default {
  name: "classList",
  components: {
    tabRule,
    tabPush,
    storeConfigure,
    vacation,
    paySetting,
    studentConfigure,
  },
  data() {
    return {
      activeName: "storeConfigure",
      showAutoWithdrawal: false, // 初始为 false，避免初次展示闪现
    };
  },

  created() {
    const cache = PageModule.pageInfo.approvalRule;
    if (cache.tab) {
      this.activeName = cache.tab;
    }
    // 获取中心配置开关详情存储到localStorage
    switchDetailApi().then((res) => {
      if (res.error_code === 0) {
        const switchDetail = {
          free_courses: false,
          student_superupper: false,
          automatic_make_up: false,
          renew_auto_switch: false,
          renew_lesson_count: 5,
          renew_push_time: "09:00",
          new_buy_renew_time: 30,
        };
        switchDetail.free_courses = res.data.free_arrange_lesson === 1;
        switchDetail.student_superupper = res.data.student_exceed === 1;
        switchDetail.automatic_make_up =
          res.data.student_exceed_automatic_sub === 1;
        switchDetail.renew_auto_switch = res.data.renew_auto_switch === 1;
        switchDetail.renew_lesson_count = res.data.renew_lesson_count;
        switchDetail.renew_push_time = res.data.renew_push_time;
        switchDetail.new_buy_renew_time = res.data.new_buy_renew_time;
        localStorage.setItem("switch_type", JSON.stringify(switchDetail));
      }
    });
    // 检查该接口是否有权限调用
    staffCheckApi({
      api_path: ["/api/v1/payment/withdraw_config/info"],
    }).then((res) => {
      if (res.data["/api/v1/payment/withdraw_config/info"]) {
        withdrawalInfoApi().then((res) => {
          if (res.error_code === 0) {
            this.showAutoWithdrawal = true;
          } else {
            this.showAutoWithdrawal = false;
          }
        });
      }
    });
  },
  methods: {
    tabChange(v) {
      PageModule.SET_PAGE_INFO({
        name: "approvalRule",
        key: "tab",
        value: v._props.name,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  /deep/.el-tabs__active-bar {
    transition: none;
  }
  /deep/.el-tabs__header {
    margin: 0 !important;
  }
}
</style>
